import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

interface Props {
  width?: string;
  height?: string;
  size?: string;
  fill?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | string;
  stroke?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'info'
    | 'subtitle2'
    | string;
  transform?: string;
  viewBox?: string;
  xmlns?: string;
  customFill?: string;
  customStroke?: string;
}

const Svg = ({
  children,
  size,
  fill,
  stroke,
  customFill,
  customStroke,
  ...props
}: PropsWithChildren<Props>) => {
  const properties = {
    ...props,
    ...(size && { width: size, height: size }),
  };
  return (
    <svg
      {...properties}
      className={classNames({
        [`fill-${fill}`]: fill,
        [`stroke-${stroke}`]: stroke,
      })}
      {...(customFill && { fill: customFill })}
      {...(customStroke && { stroke: customStroke })}
    >
      {children}
    </svg>
  );
};

export default Svg;
